import React, { useState, useRef } from "react";
import { FiInfo } from "react-icons/fi";
import "./customTooltip.scss";

const CustomTooltip = ({ content, icon }) => {
    const [isVisible, setIsVisible] = useState(false);
    const [position, setPosition] = useState("bottom");
    const tooltipRef = useRef(null);
    const iconRef = useRef(null);

    const calculatePosition = () => {
        if (!iconRef.current || !tooltipRef.current) return;

        const iconRect = iconRef.current.getBoundingClientRect();
        const tooltipWidth = 200;
        const tooltipHeight = 100;

        const spaceRight = window.innerWidth - iconRect.right;
        const spaceLeft = iconRect.left;
        const spaceBottom = window.innerHeight - iconRect.bottom;
        const spaceTop = iconRect.top;

        // Determinar la mejor posición
        if (spaceBottom >= tooltipHeight) {
            setPosition("bottom");
        } else if (spaceTop >= tooltipHeight) {
            setPosition("top");
        } else if (spaceRight >= tooltipWidth) {
            setPosition("right");
        } else {
            setPosition("left");
        }
    };

    const handleToggle = () => {
        if (!isVisible) {
            calculatePosition();
        }
        setIsVisible((prev) => !prev);
    };

    return (
        <div className="custom-tooltip" ref={tooltipRef}>
            <div
                ref={iconRef}
                className="custom-tooltip__icon"
                onClick={handleToggle}
                onMouseEnter={() => {
                    calculatePosition();
                    setIsVisible(true);
                }}
                onMouseLeave={() => setIsVisible(false)}
            >
                {icon ? (
                    icon
                ) : (
                    <FiInfo
                        className="custom-tooltip__icon-default"
                        size={18}
                    />
                )}
            </div>
            {isVisible && (
                <div
                    className={`custom-tooltip__content custom-tooltip__content--${position}`}
                >
                    {content.split("\n").map((line, index) => (
                        <div key={index} className="custom-tooltip__comment">
                            {line}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default CustomTooltip;
